import React, { useImperativeHandle, forwardRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";

interface RecaptchaComponentProps {
  onCaptchaChange: (token: string | null) => void;
  theme?: "light" | "dark";
  size?: "compact" | "normal" | "invisible";
}

const RecaptchaComponent = forwardRef((props: RecaptchaComponentProps, ref) => {
  const { onCaptchaChange, theme = "light", size = "normal" } = props;
  const recaptchaRef = React.useRef<ReCAPTCHA | null>(null);

  useImperativeHandle(ref, () => ({
    reset: () => {
      recaptchaRef.current?.reset();
      onCaptchaChange(null);
    },
  }));

  const handleCaptchaChange = (token: string | null) => {
    onCaptchaChange(token);
  };

  const handleExpired = () => {
    onCaptchaChange(null);
  };

  const handleErrored = () => {
    onCaptchaChange(null);
  };

  return (
    <div>
      <ReCAPTCHA
        ref={recaptchaRef}
        sitekey="6LcN15UqAAAAAJXL6mNNIXnS8qjmDWtnUkpYuEvA"
        theme={theme}
        size={size}
        onChange={handleCaptchaChange}
        onExpired={handleExpired}
        onErrored={handleErrored}
      />
    </div>
  );
});

export default RecaptchaComponent;
